import {
  SET_GUIDANCE_ACCEPTED,
} from '../../constants'

export default function GuidanceAcceptanceReducer(
  state = {},
  {
    type,
    path,
    response,
  } = {}
) {
  switch (type) {
    case SET_GUIDANCE_ACCEPTED: {
      const entry = state[path]
      return {
        ...state,
        [path]: {
          ...entry,
          guidanceTextAccepted: true,
        },
      }
    }

    default:
      return state
  }
}
